export default __webpack_public_path__ + "static/media/main_2_stemlife.ac4db032.png";